import toursSlice from '.';

export const { startTour, restartTour, goToStep, goBackTo, goBack, skipTour, completeTour, seedTourState } =
  toursSlice.actions;
